import { pluralize } from './count-format';

/**
 * "About 125 typical notes", "About 1 typical note": the whole typical notes `joules` covers, or `undefined`
 * while the settings are not loaded or below one typical note. Callers add " left" or lowercase it.
 */
export const formatTypicalNotes = (joules: number, creditsPerTypicalNote: number | undefined) => {
  if (creditsPerTypicalNote === undefined) return undefined;
  const typicalNotes = Math.floor(joules / creditsPerTypicalNote);
  if (typicalNotes === 0) return undefined;
  return `About ${pluralize(typicalNotes, 'typical note')}`;
};

/** "Trial: 1,000 one-time Joules · About 50 typical notes · 30 days"; without the estimate while the settings are not loaded. */
export const formatTrialAllowanceRow = (
  { trialCredits, trialDays }: { trialCredits: number; trialDays: number },
  creditsPerTypicalNote: number | undefined
) => {
  const typicalNotes = formatTypicalNotes(trialCredits, creditsPerTypicalNote);
  return [`Trial: ${pluralize(trialCredits, 'one-time Joule')}`, typicalNotes, pluralize(trialDays, 'day')]
    .filter(Boolean)
    .join(' · ');
};
